module.exports = __webpack_public_path__ + "static/media/reply.fbe8baa7.png";